import React from "react";
import {Box, Illustration, Stack, Text} from "@mbank-design/design-system/components";
import {HandThumbUpCorporate} from "@mbank-design/design-system/illustrations";

export default function SpeakerInvitationAlreadySubmitted() {
    return(
        <Box minWidth={[0, 1280]}>
            <Stack>
                <Illustration illustrationComponent={HandThumbUpCorporate} />
                <Text as={"h2"}>your registration form has already been submitted</Text>
                <Text as={"body"}>if you have any questions, please contact us using email: events@mbank.pl</Text>
            </Stack>
        </Box>
    );
}